import { isEmpty, isNil } from 'ramda';
import { createAction } from 'redux-actions';
import { batchActions } from 'redux-batched-actions';

import { resetForm, setValue } from '@gef-ui/form-core/stream/transfer/control';

import { appendMode, USER_ROLES } from 'constants/general';
import collapsibleTable from 'features/common/collapsibleTable';
import fetch from 'features/common/fetch';
// eslint-disable-next-line import/no-cycle
import documents from 'features/views/production/documents';
import { FIELDS, PRODUCED_PRODUCTION_FILTER_FORM_NAME } from 'features/views/production/documents/form';
import user from 'features/views/user';
import { trimFormData } from 'utils';

import * as types from './actionTypes';
import { getHasOrgStructureFilledToSeller, validityCheckRequestBodyFactory } from './utils';

export const disableActions = createAction(types.DISABLE_ACTIONS);
export const enableActions = createAction(types.ENABLE_ACTIONS);
export const setProductionValidity = createAction(types.SET_PRODUCTION_VALIDITY, (valid) => ({ valid }));

export const checkOrgStrukture =
	() =>
	async (dispatch, getState, { getFormData, sendControlNext }) => {
		const formData = await getFormData(PRODUCED_PRODUCTION_FILTER_FORM_NAME);

		if (isEmpty(formData?.seller) || isNil(formData?.seller)) {
			sendControlNext(
				PRODUCED_PRODUCTION_FILTER_FORM_NAME,
				setValue({ fieldName: FIELDS.withoutPpz, value: true }),
			);
		}
		if (!isEmpty(formData?.seller) && !isNil(formData?.seller)) {
			sendControlNext(
				PRODUCED_PRODUCTION_FILTER_FORM_NAME,
				setValue({ fieldName: FIELDS.withoutPpz, value: false }),
			);
		}
	};

export const disableActionButtons = () => (dispatch) => {
	dispatch(checkOrgStrukture());
	dispatch(disableActions());
};

export const resetCriteriasAndTriggerOrgStructureRefetch =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		sendControlNext(PRODUCED_PRODUCTION_FILTER_FORM_NAME, resetForm());

		// triggering refetching of orgStructure - from the beggining Channel ... etc.
		sendControlNext(PRODUCED_PRODUCTION_FILTER_FORM_NAME, setValue({ fieldName: FIELDS.channel, value: null }));
	};

export const startupProducedProduction =
	() =>
	async (dispatch, getState, { getFormData }) => {
		await dispatch(user.actions.fetchAdditionalUserInfo());
		dispatch(checkOrgStrukture());

		const state = getState();
		const userStructure = user.selectors.getRoleStructure(state);
		const { role, channelId, regionId, agencyId, managerLogin, sellerLogin, ppzLogin } = userStructure;

		// first visit page + reset process logic - to enable / disable action buttons based on set user structure
		if (getHasOrgStructureFilledToSeller(userStructure)) {
			dispatch(enableActions());
		} else {
			dispatch(disableActions());
		}

		const formData = getFormData(PRODUCED_PRODUCTION_FILTER_FORM_NAME);
		const trimmedFormData = trimFormData(formData);

		const newFormData = {
			...trimmedFormData,
			channel: channelId,
			region: regionId,
			agency: agencyId,
			manager: managerLogin,
			seller: sellerLogin,
			ppz: ppzLogin,
		};

		// todo - edit subheader auto open
		dispatch(
			batchActions([
				collapsibleTable.actions.removeOpenedRows('DocumentsTable'),
				fetch.actions.clearFetchStore(`${fetch.constants.urls.productionDocuments}.overview`),
				documents.actions.reset(),
				// role === USER_ROLES.SELLER || role === USER_ROLES.PPZ
				// 	? subheaderActions.close('production')
				// 	: subheaderActions.open('production'),
			]),
		);

		if (role !== USER_ROLES.CENTRAL) {
			dispatch(checkIfProductionIsValid());
			dispatch(
				documents.actions.load(
					{
						queryParams: documents.utils.queryParamsFactory(),
						body: documents.utils.requestBodyFactory(newFormData, role),
					},
					appendMode.SET,
					userStructure,
				),
			);
		}
	};

export const checkIfProductionIsValid =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const formData = await getFormData(PRODUCED_PRODUCTION_FILTER_FORM_NAME);
		const userRole = user.selectors.getCurrentRole(getState());

		dispatch(
			fetch.actions.post(fetch.constants.urls.hasInvalidProduction, {
				takeLatest: true,
				body: validityCheckRequestBodyFactory(formData, userRole),
				onSuccess: [
					(response) => () => {
						dispatch(setProductionValidity(Boolean(response.body)));
					},
				],
			}),
		);
	};
